import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { OriginalityService } from '../../../../../services/originality.service';
import { PromocodePrivateEmailModel } from '../../../../../models/promocode/promocode-private-email.model';
import { PromocodePrivateFilterModel } from '../../../../../models/promocode/promocode-private-filter.model';
import { DatePipe } from '@angular/common';
import { first } from 'rxjs/operators';
import { MessageService } from 'primeng';

@Component({
  selector: 'smart-generate-promocode-email',
  templateUrl: './generate-promocode-email.component.html',
  styleUrls: ['./generate-promocode-email.component.scss'],
})
export class GeneratePromocodeEmailComponent implements OnInit {

  expirationDate = new Date();

  code = '';

  discount = 0;

  subject = '';

  emailText = '';

  withFeedback = false;

  filter = null;

  loading = false;

  manualEmailsBtns = [{ label: 'Príjemcovia e-mailu podľa filtra', value: false }, {
    label: 'Zadať príjemcov emailu manuálne',
    value: true,
  }];

  manualEmails = this.manualEmailsBtns[0];

  emailAddresses: string[] = [];

  @ViewChild('staticModal', { static: false }) modal: ModalDirective;

  @Output() forceRefreshData: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    protected originality: OriginalityService,
    private datePipe: DatePipe,
    private messageService: MessageService,
  ) {
  }

  ngOnInit() {
  }

  openModal(filter: any) {
    this.filter = filter;

    if (this.filter.page) {
      delete this.filter.page;
    }

    if (this.filter.pageSize) {
      delete this.filter.pageSize;
    }

    this.modal.show();
  }

  close() {
    this.modal.hide();
  }

  submit() {
    let promocode;

    if (this.manualEmails.value) {
      promocode = new PromocodePrivateEmailModel();
      promocode.emails = this.emailAddresses;
    } else {
      promocode = new PromocodePrivateFilterModel();
      promocode.filter = this.filter;
    }

    promocode.expirationDatetime = this.datePipe.transform(this.expirationDate, 'yyyy-MM-dd');
    promocode.discountPercentage = this.discount;
    promocode.emailBody = this.emailText;
    promocode.emailSubject = this.subject;
    promocode.sendQuestionnaire = this.withFeedback;

    this.loading = true;

    let api;

    if (this.manualEmails.value) {
      api = this.originality.generatePromoCodeForUser(promocode);
    } else {
      api = this.originality.generatePromoCodeForUserByFilter(promocode);
    }

    api.pipe(first())
      .subscribe({
        next: () => {
          this.messageService.add({ severity: 'success', summary: 'E-Mail odoslaný na spracovanie.' });
          this.close();
          this.loading = false;
          this.forceRefreshData.emit(true);
        },
        error: () => {
          this.loading = false;
          this.messageService.add({ severity: 'error', summary: 'Nastala chyba.' });
        },
      });
  }

}
